// extracted by mini-css-extract-plugin
export default {"coordinates":"hMMJq","coordinatesIcon":"m02Me","shareMessage":"WXWT4"};